var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    fillOpacity: 0.12,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M15.506 13.002h-.5v10.637h1v-9.637h10.05v5.414a.5.5 0 0 0 .5.5h5.45v13.36h-4.6v1h5.6V19.442a.467.467 0 0 0 0-.053v-.182l-.138-.137a.535.535 0 0 0-.018-.018l-5.926-5.889a.477.477 0 0 0-.03-.03l-.132-.131H15.506Zm11.55 1.702v4.212h4.238l-4.237-4.212Zm-8.08 11.142a2.89 2.89 0 0 0-2.9 2.88 2.89 2.89 0 0 0 2.9 2.878 2.9 2.9 0 0 0 2.073-.866 2.86 2.86 0 0 0 .827-2.013 2.89 2.89 0 0 0-2.9-2.88Zm3.091 5.245c.507-.654.81-1.475.81-2.366 0-2.145-1.75-3.88-3.9-3.88-2.152 0-3.9 1.735-3.9 3.88 0 2.145 1.748 3.88 3.9 3.88.896 0 1.722-.302 2.381-.808l2.366 2.351.355.352.705-.709-.355-.352-2.362-2.348Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.006,
    x2: 33.007,
    y1: 23.751,
    y2: 23.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant8);
export default __webpack_public_path__ + "static/media/variant8.10e57877d5c7fdd6232db935bd9a5da9.svg";
export { ForwardRef as ReactComponent };